import { render, staticRenderFns } from "./RipaAdminContainer.vue?vue&type=template&id=c430a566"
import script from "./RipaAdminContainer.vue?vue&type=script&lang=js"
export * from "./RipaAdminContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports